import ResumenPago from 'components/Resumen/ResumenPago'
import React from 'react'
import { PRODUCTOS } from 'utils/constants'
import { CYBER } from './constantes/general'

export const CyberResumen = (props) => {

    const procesarInfo=(resp)=>{
        resp.prodDatos[0].planSeleccionado.etiquetas=[
            {label:"Suma Asegurada",id:'sumaAsegurada'},
            {label:"Ingreso anual bruto",id:'ingresoBruto'},
            {label:"Deducible para toda y cada pérdida",id:"deducibleValor"}
        ]
        return resp;
    }

    return (
        <ResumenPago productoCodigoCore={PRODUCTOS.CYBER}
            urlGoTo={CYBER.urls.facturacion}
            urlBackTo={CYBER.urls.planes}
            procesarInfo={procesarInfo}
            {...{ ...props }}></ResumenPago>
    )
}
